import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box } from '@mui/material';
import cx from 'classnames';

import { ECOSYSTEM_STATUS } from 'enum';
import LOGO_IMG from 'assets/logo/logo_black.svg';
import LOGO_IMG_SM from 'assets/logo/logo.svg';
import HeaderLinks from '../HeaderLinks';

import './styles.scss';

const EcosystemHeader = ({ customer, ecosystems, activeTab, onChangeTab }) => {
  const isEcosystemAvailable = useMemo(
    () =>
      ecosystems.some((ecosystem) =>
        [ECOSYSTEM_STATUS.PENDING_CHANGES, ECOSYSTEM_STATUS.OK, ECOSYSTEM_STATUS.COMMIT_IN_PROGRESS].includes(
          ecosystem.status,
        ),
      ),
    [ecosystems],
  );

  return (
    <div className="ecosystems__navbar">
      <div className="logo">
        <a href="/" className="simple-text logo-normal full-width">
          <div className="logo-img">
            {customer.logo ? (
              <img src={customer.logo} className="customer-logo" alt="logo_image" />
            ) : (
              <>
                <img src={LOGO_IMG} className="bigLogo" alt="logo_image" />
                <img src={LOGO_IMG_SM} className="smallLogo" alt="logo_image" />
              </>
            )}
          </div>
        </a>
      </div>
      <div className="main-panel">
        <Box component="nav" className="navbar navbar-default">
          <Box className="container-fluid">
            <Box className="navbar-header">
              <Box className="navbar-brand ecosystem_summary">
                <div className={cx({ active: activeTab === 'all' })} onClick={() => onChangeTab('all')}>
                  All Ecosystems
                </div>
              </Box>
              <Box className="navbar-brand ecosystem_summary">
                <div
                  className={cx({ active: activeTab === 'summary', disabled: !isEcosystemAvailable })}
                  onClick={() => onChangeTab('summary')}
                >
                  Dashboard
                </div>
              </Box>
              <Box className="navbar-brand ecosystem_summary">
                <div
                  className={cx({ active: activeTab === 'threat', disabled: !isEcosystemAvailable })}
                  onClick={() => onChangeTab('threat')}
                >
                  Threat Report
                </div>
              </Box>
            </Box>
            <Box className="navbar-collapse collapse">
              <HeaderLinks showSearch={false} />
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
};

EcosystemHeader.propTypes = {
  customer: PropTypes.object,
  activeTab: PropTypes.string,
  onChangeTab: PropTypes.func,
  ecosystems: PropTypes.array,
};

const mapStateToProps = (state) => ({
  customer: state.customers.currentCustomer,
  ecosystems: state.ecosystems.items,
});

export default connect(mapStateToProps)(EcosystemHeader);
